import Axios from "axios";

const updateUserAPI = (data, cb) => {
  Axios({
    method: "PUT",
    url: `${process.env.REACT_APP_BASE_URL}/updateUser`,
    data: data,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
    .then((response) => {
      cb(response);
    })
    .catch((err) => {
      cb(err);
    });
};

export default updateUserAPI;
